@if (specialties() && specialties()!.length > 0) {
  <div class="flex flex-wrap gap-3">
    @for (spec of specialties()!; track spec) {
      @let info = getSpecialtyInfo(spec);
      <div
        class="inline-flex items-center gap-2.5 px-4 py-2.5 rounded-xl text-xs font-semibold bg-white dark:bg-neutral-2 text-neutral-12 border border-neutral-3 dark:border-neutral-4 shadow-xs hover:border-neutral-4 dark:hover:border-neutral-5 transition-colors"
      >
        <div
          class="w-7 h-7 rounded-lg bg-primary-2 text-primary-11 flex items-center justify-center shrink-0"
        >
          <mat-icon class="!w-4 !h-4 !text-base">{{ info.icon }}</mat-icon>
        </div>
        <span class="font-bold">{{ info.label }}</span>
      </div>
    }
  </div>
} @else {
  <div
    class="p-6 text-center border-2 border-dashed border-neutral-3 dark:border-neutral-4 rounded-2xl bg-white dark:bg-neutral-2 shadow-xs"
  >
    <p class="text-xs text-neutral-9 italic">
      Aucune spécialité de transactions sélectionnée pour le moment.
    </p>
  </div>
}
